import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, nullable } from '../../shared/forms/validators';

const schema = [
  {
    name: 'slAccount',
    component: InputFormik,
    meta: { label: 'SL Account' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'slView',
    component: SelectFormik,
    meta: { label: 'View', optionsKey: 'slViewOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'lifecycleMap',
    component: SelectFormik,
    meta: { label: 'Lifecycle Map', optionsKey: 'lifecycleMapOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
  },
];

export default schema;
